enum PhoneType {
    MOBILE = "MOBILE",
    HOME = "HOME",
    WORK = "WORK"
}

export default PhoneType;